import React, { useContext, useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { faDownload, faRetweet } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Pagination } from "../../../Components/Pagination";
import Swal from "sweetalert2";
import { DataContext } from "../../../App";
import XLSX from "xlsx-js-style";
import * as FileSaver from "file-saver";

export default function ThongKeNhapXuatTon() {
  const { dataNhapXuatTon: initialData, isLoadingNhapXuatTon } =
    useContext(DataContext);

  const { proxy, lang } = useSelector((state) => state);
  const [data, setData] = useState([]);
  const [backupData, setBackupData] = useState(data);
  const [dataSearch, setDataSearch] = useState();

  const [refresh, setRefresh] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState();
  const _token = localStorage.getItem("_token");
  const [currentPage, setCurrentPage] = useState(1);
  const dataPerPage = 8;
  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData =
    dataSearch && dataSearch.slice(indexOfFirstData, indexOfLastData);
  const totalPages = dataSearch && dataSearch.length;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const debounceTimeout = useRef(null);

  useEffect(() => {
    if (initialData && initialData.length > 0) {
      setData(initialData);
      setBackupData(initialData);
      setDataSearch(initialData);
    }
  }, [initialData]);

  useEffect(() => {
    const fetchData = async () => {
      const searchParams = new URLSearchParams(search).toString();
      try {
        const response = await fetch(
          proxy() + `/api/stats/Kho/SoLot?${searchParams}`,
          {
            method: "POST",
            headers: {
              Authorization: _token,
              "content-type": "application/json",
            },
          }
        );
        const result = await response.json();
        if (result?.length) {
          if (data.length === 0) {
            setBackupData(result);
            setData(result);
          }
          setDataSearch(result);
        } else {
          if (search) {
            setDataSearch([]);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        Swal.close();
        setLoading(false);
      }
    };
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    if (search && Object.keys(search).length === 0 && data.length > 0) {
      setDataSearch(backupData);
    } else if (search) {
      debounceTimeout.current = setTimeout(() => {
        Swal.fire({
          title: lang["searching"],
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        const filters = [
          { key: "SoLot", value: search.SoLot },
          { key: "LDB", value: search.LichDongBao },
          { key: "MSP", value: search.MaSP },
          { key: "TenSP", value: search.TenSP },
          { key: "dongbao", value: search.DongBao },
          { key: "nhap", value: search.Nhap },
          { key: "xuat", value: search.Xuat },
          { key: "ton", value: search.Ton },
          { key: "TNHuy", value: search.TNHuy },
        ];
        const filteredData = backupData.filter((item) => {
          return filters.every(({ key, value }) => {
            if (value) {
              if (Array.isArray(item[key])) {
                return item?.[key]?.some((arrayItem) =>
                  String(arrayItem).includes(String(value))
                );
              } else if (key === "MSP") {
                return (
                  String(item[key]).includes(String(value)) ||
                  String(item["TenSP"]).includes(String(value))
                );
              } else {
                return String(item[key]).includes(String(value));
              }
            }
            return true;
          });
        });

        setDataSearch(filteredData);
        setCurrentPage(1);
        Swal.close();
      }, 1000);
    } else {
      fetchData();
    }
  }, [refresh, search]);

  function getFormattedDateTime() {
    const now = new Date();

    const pad = (n) => (n < 10 ? "0" + n : n);

    const day = pad(now.getDate());
    const month = pad(now.getMonth() + 1);
    const year = now.getFullYear();

    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());

    return `${year}-${month}-${day}_${hours}H${minutes}`;
  }

  const handleExportExcel = () => {
    const headers = [
      "Số Lot",
      "Lệnh Đóng Bao",
      "Sản Phẩm",
      "Đóng Bao",
      "Nhập",
      "Xuất",
      "Thu Hồi Tái Nhập",
      "Tồn",
    ];

    const mappedData = data.map((item) => [
      item?.SoLot,
      (item?.LDB).join("\n"),
      `${item?.MSP}\n${item?.TenSP}`,
      item?.dongbao,
      item?.nhap,
      item?.xuat,
      item?.TNHuy,
      item?.ton,
    ]);

    const sheetData = [headers, ...mappedData];
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    for (let C = 0; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      const cell = worksheet[cellAddress];
      if (cell) {
        cell.s = {
          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
          },
          fill: { patternType: "solid", fgColor: { rgb: "FF13A023" } },
          font: { bold: true, color: { rgb: "FFFFFFFF" } },
        };
      }
    }

    for (let R = 1; R <= range.e.r; ++R) {
      for (let C = 0; C <= range.e.c; ++C) {
        const addr = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = worksheet[addr];
        if (cell) {
          if (!cell.s) cell.s = {};
          if (!cell.s.alignment) cell.s.alignment = {};
          cell.s.alignment.wrapText = true;
          cell.s.alignment.horizontal = "center";
          cell.s.alignment.vertical = "center";
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const buffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });

    const file = new Blob([buffer], { type: "application/octet-stream" });
    FileSaver.saveAs(
      file,
      `DATA_Thống Kê Xuất-Nhập-Tồn_${getFormattedDateTime()}.xlsx`
    );
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row" style={{ margin: "5px -15px" }}>
          <div className="col-md-12">
            <div className="white_shd full">
              <div className="tabbar padding_infor_info_p-d-5">
                <div>
                  <div className="d-flex align-items-center page-title position-relative mb-0">
                    <span
                      style={{
                        fontSize: "18px",
                        color: "rgb(68, 161, 161)",
                      }}
                    >
                      THỐNG KÊ XUẤT-NHẬP-TỒN
                    </span>
                    <div className="ml-auto d-flex align-items-center">
                      <FontAwesomeIcon
                        icon={faRetweet}
                        className="icon-add mr-2 pointer"
                        fontSize={2}
                        style={{
                          color: "rgb(224, 118, 42)",
                        }}
                        onClick={() => {
                          setRefresh((prev) => prev + 1);
                          setSearch();
                          Swal.fire({
                            title: "Đang tải lại dữ liệu...",
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            didOpen: () => {
                              Swal.showLoading();
                            },
                          });
                        }}
                      />
                      <FontAwesomeIcon
                        className="pointer"
                        icon={faDownload}
                        fontSize={27}
                        color="#269c1b"
                        onClick={handleExportExcel}
                      />
                    </div>
                  </div>
                  <hr
                    style={{
                      border: "1px solid rgb(221, 221, 221)",
                      margin: "0px -11px 5px",
                    }}
                  />
                  <div className="table-display d-flex">
                    <div className="table-responsive table-custom design-table _table-custom">
                      <Table>
                        <thead>
                          <tr>
                            <td>#</td>
                            {[
                              "Số Lot",
                              "Lệnh Đóng Bao",
                              "Sản Phẩm",
                              "Đóng Bao",
                              "Nhập",
                              "Xuất",
                              "Thu Hồi Tái Nhập",
                              "Tồn",
                            ].map((item) => (
                              <td key={item}>{item}</td>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <>
                            <tr>
                              <td></td>
                              {[
                                "SoLot",
                                "LichDongBao",
                                "MaSP",
                                "DongBao",
                                "Nhap",
                                "Xuat",
                                "TNHuy",
                                "Ton",
                              ].map((item) => (
                                <td>
                                  <input
                                    key={refresh}
                                    className="form-control"
                                    onChange={(e) => {
                                      const { value } = e.target;

                                      setSearch((prev) => {
                                        const newPrev = { ...prev };
                                        if (value) {
                                          newPrev[item] = value.trim();
                                        } else {
                                          delete newPrev[item];
                                        }
                                        return newPrev;
                                      });
                                    }}
                                  />
                                </td>
                              ))}
                            </tr>
                            {loading ? (
                              <td className="align-center" colSpan={10}>
                                <img
                                  width={40}
                                  // className="loading-image"
                                  src="/images/icon/load.gif"
                                  alt="Loading..."
                                  // style={{
                                  //   position: "absolute",
                                  //   top: "50%",
                                  //   left: "50%",
                                  //   transform: "translate(-50%, -50%)",
                                  //   zIndex: 2,
                                  // }}
                                />
                              </td>
                            ) : currentData && currentData.length > 0 ? (
                              currentData.map((item, index) => {
                                return (
                                  <tr>
                                    <td>{indexOfFirstData + index + 1}</td>
                                    <td>{item?.SoLot}</td>
                                    <td>
                                      <ul
                                        className="ml-4"
                                        style={{
                                          listStyleType: "unset",
                                        }}
                                      >
                                        {item?.LDB?.map((item) => (
                                          <li>
                                            <span
                                              style={{
                                                fontWeight: "bold",
                                                color: "rgb(116, 158, 192)",
                                              }}
                                            >
                                              {item}
                                            </span>
                                          </li>
                                        ))}
                                      </ul>
                                    </td>
                                    <td>
                                      {item?.MSP}
                                      <br />
                                      {item?.TenSP}
                                    </td>
                                    <td>{item?.dongbao}</td>
                                    <td>{item?.nhap}</td>
                                    <td>{item?.xuat}</td>
                                    <td>{item?.TNHuy}</td>
                                    <td>{item?.ton}</td>
                                  </tr>
                                );
                              })
                            ) : (
                              <td className="align-center" colSpan={10}>
                                {lang["not found"]}
                              </td>
                            )}
                          </>
                        </tbody>
                      </Table>
                    </div>
                    {currentData && currentData.length > 0 && (
                      <Pagination
                        total={totalPages}
                        itemsPerPage={dataPerPage}
                        currentPage={currentPage}
                        paginate={paginate}
                        lang={lang}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
